import { createSlice } from '@reduxjs/toolkit'
import { getSpecialtyConsultationAll } from '../services/specialtyService'

const initialState = {
  list: [],
  loading: false,
  error: null
}

const specialtySlice = createSlice({
  name: 'specialty',
  initialState,
  reducers: {
    requestStart(state) {
      state.loading = true
      state.error = null
    },
    requestSuccess(state, action) {
      state.loading = false
      state.list = action.payload
    },
    requestFailure(state, action) {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const { requestStart, requestSuccess, requestFailure } = specialtySlice.actions
export default specialtySlice.reducer

/**
 * Fabrica lista de todas as especialidades de consulta.
 */
export const fetchSpecialtyConsultationAll = () => async (dispatch, getState) => {
  try {
    const state = getState()

    // carrega apenas uma vez
    if (state.specialty.loading) return
    if (state.specialty.list.length) return

    dispatch(requestStart())

    const response = await getSpecialtyConsultationAll()

    dispatch(requestSuccess(response))

  } catch (error) {
    dispatch(requestFailure(error.message))
  }
}
